import ClientTelemetryPage from "./ClientTelemetryPage";

export default ClientTelemetryPage;
